"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _FootballMatchTimer = _interopRequireDefault(require("./FootballMatchTimer"));

var _FootballMatchScoreUpdate = _interopRequireDefault(require("./FootballMatchScoreUpdate"));

require("moment/locale/nl");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  width: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

var StyledClub = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 0 0 30px;\n  max-width: 30px;\n  width: 30px;\n  height: 3rem;\n  padding: 0 0 2px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"])));

var StyledClubLogo = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 26px;\n  margin-bottom: 2px;\n"])));

var StyledClubName = (0, _styledComponents.default)(_fiverReactUiComponents.ClubName)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 0.75rem;\n  line-height: 1.25;\n  white-space: nowrap;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.96);\n"])));

var StyledScore = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 0 0 56px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.96);\n"])));

var StyledScoreValue = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

var StyledScoreValueBlock = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  text-align: ", ";\n"])), function (p) {
  return p.isRight ? "left" : "right";
});

var StyledScoreTime = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 0.8rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.67);\n"])));

var StyledScoreValueColon = _styledComponents.default.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  height: 14px;\n  margin: 0 3px;\n"])));

var StyledColorCircle = _styledComponents.default.circle(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  fill: rgba(255, 255, 255, 0.96);\n"])));

var StyledVsWrapper = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));

var StyledVs = _styledComponents.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: 1.25rem;\n  color: rgba(255, 255, 255, 0.66);\n  margin-bottom: 2px;\n"])));

var StyledVsLock = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  color: rgba(255, 255, 255, 0.66);\n  font-size: 18px;\n  margin-bottom: 4px;\n"])));

var StyledVsDate = _styledComponents.default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.46);\n  font-size: 0.575rem;\n  margin-bottom: 2px;\n  text-align: center;\n  max-width: 55px;\n"])));

var Wrapper = function Wrapper(_ref) {
  var _footballMatch$homeTe, _footballMatch$homeTe2, _footballMatch$homeTe3, _footballMatch$awayTe, _footballMatch$awayTe2, _footballMatch$awayTe3;

  var language = _ref.language,
      hasGoalScored = _ref.hasGoalScored,
      footballMatch = _ref.footballMatch,
      isLocked = _ref.isLocked,
      isApproved = _ref.isApproved,
      isInPlay = _ref.isInPlay,
      isCompleted = _ref.isCompleted,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      onAnimationEnd = _ref.onAnimationEnd;

  // UNCOMMENT TO TEST MATCH TIMER
  // isInPlay = true;
  // isCompleted = false;
  // footballMatch.period = "SecondHalf";
  // footballMatch.homeScore = 0;
  // footballMatch.awayScore = 0;
  // footballMatch.matchTime = 2;
  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      activePickem = _useSelector.activePickem,
      activePickemList = _useSelector.activePickemList;

  var hasMultipleBetOption = (activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) > 1;
  var locale, timezone;

  if (language === "dutch") {
    locale = "nl";
    timezone = "Europe/Amsterdam";
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledClub, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubLogo, {
        src: (footballMatch === null || footballMatch === void 0 ? void 0 : (_footballMatch$homeTe = footballMatch.homeTeam) === null || _footballMatch$homeTe === void 0 ? void 0 : _footballMatch$homeTe.logoImg) || (footballMatch === null || footballMatch === void 0 ? void 0 : (_footballMatch$homeTe2 = footballMatch.homeTeam) === null || _footballMatch$homeTe2 === void 0 ? void 0 : _footballMatch$homeTe2.logo)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
        isLetters: true,
        children: footballMatch === null || footballMatch === void 0 ? void 0 : (_footballMatch$homeTe3 = footballMatch.homeTeam) === null || _footballMatch$homeTe3 === void 0 ? void 0 : _footballMatch$homeTe3.name
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledScore, {
      children: [isApproved && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledVsWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledVs, {
          children: "vs"
        }), hasMultipleBetOption && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledVsDate, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.DateTime, {
            locale: locale,
            format: "ddd H:mm",
            timezone: timezone,
            children: activePickem === null || activePickem === void 0 ? void 0 : activePickem.start
          })
        })]
      }), !isApproved && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledScoreValue, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledScoreValueBlock, {
            children: footballMatch === null || footballMatch === void 0 ? void 0 : footballMatch.homeScore
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledScoreValueColon, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
              width: "4",
              height: "4",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColorCircle, {
                cx: "2",
                cy: "2",
                r: "2"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
              width: "4",
              height: "4",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColorCircle, {
                cx: "2",
                cy: "2",
                r: "2"
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledScoreValueBlock, {
            isRight: true,
            children: footballMatch === null || footballMatch === void 0 ? void 0 : footballMatch.awayScore
          })]
        }), isInPlay || isCompleted ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledScoreTime, {
          children: (footballMatch === null || footballMatch === void 0 ? void 0 : footballMatch.period) === "FirstHalf" || (footballMatch === null || footballMatch === void 0 ? void 0 : footballMatch.period) === "SecondHalf" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FootballMatchTimer.default, {
            matchTime: footballMatch === null || footballMatch === void 0 ? void 0 : footballMatch.matchTime
          }) : (footballMatch === null || footballMatch === void 0 ? void 0 : footballMatch.period) === "HalfTime" ? "HT" : (footballMatch === null || footballMatch === void 0 ? void 0 : footballMatch.period) === "FullTime" || isCompleted ? "FT" : null
        }) : null]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledClub, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubLogo, {
        src: (footballMatch === null || footballMatch === void 0 ? void 0 : (_footballMatch$awayTe = footballMatch.awayTeam) === null || _footballMatch$awayTe === void 0 ? void 0 : _footballMatch$awayTe.logoImg) || (footballMatch === null || footballMatch === void 0 ? void 0 : (_footballMatch$awayTe2 = footballMatch.awayTeam) === null || _footballMatch$awayTe2 === void 0 ? void 0 : _footballMatch$awayTe2.logo)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
        isLetters: true,
        children: footballMatch === null || footballMatch === void 0 ? void 0 : (_footballMatch$awayTe3 = footballMatch.awayTeam) === null || _footballMatch$awayTe3 === void 0 ? void 0 : _footballMatch$awayTe3.name
      })]
    })]
  });
};

var _default = Wrapper;
exports.default = _default;